app.component("patientPhone", {
	templateUrl: "app/src/js/components/patientHeader/patientPhone/patientPhone.html",
	controller: "patientPhoneController",
	bindings: {
		hide: "&",
	},
});

app.controller("patientPhoneController", [
	"$scope",
	"PreOp",
	"NHI",
	"CurrentPatient",
	"PatientAPI",
	"$timeout",
	"Session",
	function ($scope, PreOp, NHI, CurrentPatient, PatientAPI, $timeout, Session) {
		this.$onInit = function () {
			$scope.preop = PreOp;
			$scope.PA = PatientAPI;
			this.PA = PatientAPI;
			$scope.CP = CurrentPatient;
			$scope.formData = {
				phone: "",
			};
		};
	
		// Writes the mobile number: phoneNumber is deprecated, and a landline cannot receive the
		// verification link or code that patient comms depend on.
		$scope.savePhone = function (mobileNumber) {
			const previousMobileNumber = $scope.CP.patient.mobileNumber;
			$scope.CP.patient.mobileNumber = mobileNumber;
			if(!$scope.CP.patient.id) {
				$scope.$ctrl.hide();
				return;
			} 
			$scope.PA.isProcessing = true;
			$scope.PA.update($scope.CP.patient)
				.then(function (resp) {
					$scope.CP.setPatient(resp.data);
				})
				.then(function () {
					$scope.PA.isProcessing = false;
					$scope.$ctrl.hide();
				})
				.catch(function (err) {
					// Not saved, so the header goes back to showing what is on file.
					$scope.CP.patient.mobileNumber = previousMobileNumber;
					$scope.PA.isProcessing = false;
					console.error("Failed to save mobile number:", err && err.status);
				});
		};
	},
]);
